var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Carousel from '@marketing/components/global/Carousel';
import Video from '@marketing/components/sections/non_product/Media/Video';
import { useMediaQuery } from '@mui/material';
function pauseVideos() {
    var embedIframes = document.querySelectorAll('.vimeo-embed-iframe');
    embedIframes.forEach(function (iframe) {
        if (iframe.contentWindow) {
            // Pause Youtube Videos
            if (iframe.src.startsWith('https://www.youtube.com')) {
                iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            }
            // Pause Vimeo Videos
            if (iframe.src.startsWith('https://player.vimeo.com/')) {
                iframe.contentWindow.postMessage('{"method":"pause"}', '*');
            }
        }
    });
}
function VideoCarousel(_a) {
    var videos = _a.videos, _b = _a.theme, theme = _b === void 0 ? 'dark' : _b;
    var gap = useMediaQuery('(min-width: 768px)') ? 48 : 8;
    return (_jsx("div", __assign({ className: "w-full md:w-[592px] mx-auto" }, { children: _jsx(Carousel, __assign({ theme: theme, controlsPadding: "!px-0 !pt-xl-m md:!pt-[23px]", gap: gap, onSelectIndex: pauseVideos, hideOverflow: false }, { children: videos.map(function (video, index) { return (_jsx(Video, { src: video.src, title: video.title }, index)); }) })) })));
}
export default VideoCarousel;
